export default "__VITE_ASSET__lgIk1B3m__"